<div class="relative flex flex-row w-full items-end justify-center px-3 pb-1.5"
[ngClass]="{'footer-vet-pet24': userSession?.rol === rolVet, 'footer-pet24': userSession?.rol === rolClient || userSession === null}"
>
    <div class="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-white text-center text-xs lg:text-sm">
        <span>Copyright © {{currentYear}} v.{{ version }}</span>
        <a href="https://www.auracode.co" target="_blank" rel="noopener noreferrer" class="underline">ATC</a>
        <span>Todos los derechos reservados.</span>
        <img src="assets/images/pet24-icon-2.png" alt="PET24" class="h-6 w-auto" />
    </div>
</div>